import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import './index.scss'

const DeleteOneStoryFromChat = ({ img, time, name, town, avtor }) => (
  <Grid className='likeBox'>
    <Grid className='contentBox'>
      {!avtor && <img className='imgStory' src={img} />}
      <Grid>
        <Typography className='descText'>
          {avtor ? 'You removed the story so all related chats were automatically deleted.' : `The story was removed by ${name} and your chat with ${name} was deleted.`}
        </Typography>
        <Typography className='time'>{moment(+time)?.startOf('minutes')?.fromNow()}</Typography>
      </Grid>
    </Grid>
  </Grid>
)

export default DeleteOneStoryFromChat
